<template>
  <div class="guide">
    <div class="card-guide-body">
      <b-row>
        <b-col>
          <button-toolbar
            :items="items"
            :status="status"
            @add-item-click="handleAddItemClick"
            @status-click="handleStatusClick"
            @search-input="handleSearchInput"
          />
        </b-col>
      </b-row>
      <data-table
        :items="items"
        @update-status-click="handleUpdateStatusClick"
        @update-memory-click="handleUpdateMemoryClick"
      />
    </div>
    <add-edit-item-modal
      :ref="addEditItemModalId"
      :item-status-modal-id="addEditItemModalId"
      :profile="profile"
      @item-added="handleItemAdded"
      @item-updated="handleItemUpdated"
    />
    <update-status-modal
        :ref="updateStatusModalId"
        :profile="profile"
        @item-status-updated="handleStatusUpdated"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";
import DataTable from "./dataTable";
import ButtonToolbar from "./buttonToolbar";
import AddEditItemModal from "./addEditItemModal";
import UpdateStatusModal from "./updateStatusModal";
export default {
  name: "Memories_Forms",
  components: {
    AddEditItemModal,
    ButtonToolbar,
    DataTable,
    UpdateStatusModal
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({
      allMemories: "admin/memories"
    }),
    items() {
      if (this.searchStr.trim() == "" && !this.status) return this.allMemories;

      let filtered = [];
      let searchStrTrim = this.searchStr.trim() != "" ? this.searchStr.trim().toLowerCase() : null;

      filtered = this.allMemories.filter(anItem => {
        return (anItem.status == this.status || !this.status) &&
            (
                (anItem.form && anItem.form.name && anItem.form.name.toLowerCase().includes(searchStrTrim)) ||
                (anItem.form && anItem.form.name && anItem.form.comment.toLowerCase().includes(searchStrTrim))
            );
      });

      return filtered;
    }
  },
  mounted() {},
  methods: {
    handleSearchInput(search){
      this.searchStr = search;
    },
    handleStatusClick(status){
      this.status = status;
    },
    handleActivation() {
      //lazy load only on selection. Prevent unecessary pulls and other benefits
      this.getMemories();
    },
    getMemories() {
      debugger;
      this.$store.dispatch("admin/getMemories").then(res => {
        console.log(res);
      });
    },
    formatDate(date) {
      return date
        ? moment(date.toDate()).format("MMMM DD, YYYY h:MM a")
        : "N/A";
    },
    handleAddItemClick() {
      if (this.$refs[this.addEditItemModalId].hasOwnProperty("handleAddItem")) {
        this.$refs[this.addEditItemModalId].handleAddItem();
      }
    },
    handleUpdateStatusClick(item) {
      if (
        this.$refs[this.updateStatusModalId].hasOwnProperty(
          "handleOpenStatusModalForItem"
        )
      ) {
        this.$refs[this.updateStatusModalId].handleOpenStatusModalForItem(item);
      }
    },
    handleUpdateMemoryClick(item) {
      if (
          this.$refs[this.addEditItemModalId].hasOwnProperty("handleUpdateItem")
      ) {
        this.$refs[this.addEditItemModalId].handleUpdateItem(item);
      }
    },
    handleItemAdded(item){
      this.handleItemAddedUpdated(item,'added');
    },
    handleItemUpdated(item){
      this.handleItemAddedUpdated(item,'updated');
    },
    handleItemAddedUpdated(item, action){
      this.$store.dispatch("user/showNotification", {
        title: `Memory ${ item && item.name ? item.name: ""} ${action}!`,
        description: `Your item has been ${action}`,
        variant: "success"
      });
      this.getMemories();
    },
    handleStatusUpdated(updates){
      this.$store.dispatch("user/showNotification", {
        title: `A Memory Status Updated`,
        description: `Your item has been ${updates.status}.`,
        variant: "success"
      });
      this.getMemories();
    }
  },
  data() {
    return {
      searchStr: "",
      status: null, //|all | submitted | needs_work | inactive
      addEditItemModalId: "add-edit-status-modal-now",
      updateStatusModalId: "update-status-modal",
      btnText: "Approve",
      transProps: {
        name: "flip-list" // Transition name
      },
      fields: [
        { key: "email", sortable: true, label: "Email" },
        { key: "ip_address", sortable: true, label: "IP Address " },
        {
          key: "_created_at",
          sortable: true,
          label: "Submitted",
          formatter: "formatDate"
        }
        // { key: "actions", label: "Actions" }
        //     { key: "show_details", label: "Show Details" }
      ],
      currentPage: 1,
      perPage: 50,
      pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
      selectedUser: {},
      showUserNotify: true
    };
  }
};
</script>
<style lang="scss" scoped>
.card-guide {
  box-shadow: none;
}
</style>
